import { Backdrop, CircularProgress, Stack, Typography, useTheme } from "@mui/material";

const LoadingScreen = ({ title, open }) => {
  const theme = useTheme();
  return (
    <Backdrop
      sx={{
        color: theme.palette.primary.main,
        zIndex: `${(theme) => theme.zIndex.drawer + 1500} !important`,
        margin: "0 !important",
        "&.MuiBackdrop-root": {
          backgroundColor: "rgba(0, 0, 0, 0.7)",
        },
      }}
      open={open}
    >
      <Stack sx={{ justifyContent: "center", alignItems: "center" }}>
        <CircularProgress color="inherit" size="5rem" />
        <Typography variant="subtitle2" m={2}>
          {title}
        </Typography>
      </Stack>
    </Backdrop>
  );
};

export default LoadingScreen;
